import _asyncToGenerator from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/.pnpm/@babel+runtime@7.14.6/node_modules/@babel/runtime/regenerator/index.js";
/* eslint-disable max-len */
import _ from 'lodash';
import flow from 'lodash/fp/flow';
import map from 'lodash/fp/map';
import filter from 'lodash/fp/filter';
import uniqBy from 'lodash/fp/uniqBy';
import { isBlank } from 'underscore.string';
import { toJS } from 'mobx';
// eslint-disable-next-line import/no-extraneous-dependencies
import Big from 'big.js';
import { safeToBig } from 'shared/helpers/utils_math';
// eslint-disable-next-line import/no-cycle
import { taxes } from 'shared/order/taxes';
import { isRecOnly, isMedOnly } from 'shared/core/helpers/dispensaries';
import { adminFilteredProducts } from 'shared/graphql/product/queries';
import { getComplianceConfig } from 'shared/core/helpers/compliance';
import { DefaultImages, POTENCY_TYPES, POTENCY_UNITS, POTENCY_UNITS_DISPLAY, productEffects, StrainTypeOrder, MILLIGRAMS, GRAMS, MG_TO_G, MILLILITERS, WeightedSubcategories } from 'shared/constants';
import { replaceAWSSourceWithImgix } from 'shared/helpers/imgix';
import { GRAM_TO_OZ, GRAM_WEIGHT_REGEX, OZ_WEIGHT_REGEX, MG_WEIGHT_REGEX, CONC_WEIGHT_REGEX, PARTIAL_OZ_REGEX, MILLILITERS_PER_OZ, MULTIPLIER_REGEX, CategoryOptions, CategoriesForMenu, SubcategoryOptions } from 'shared/constants/products';
import { CannabinoidAbbrev } from 'shared/constants/cannabinoids';
import { parseNoidAbbreviation } from 'shared/utils/misc-utils';

/**
 * @param {Pick<import('types/graphql').GqlProducts, 'type' | 'Options'>} product
 * @returns {boolean}
 */
export var isWeightedProduct = function isWeightedProduct(_ref) {
  var type = _ref.type,
    _ref$Options = _ref.Options,
    Options = _ref$Options === void 0 ? [] : _ref$Options;
  if (_.includes(['Flower', 'Vaporizers', 'Concentrate'], type) && !_.includes(Options, 'N/A')) {
    return true;
  }
  if (type === 'Pre-Rolls' && Options.length && parseFloat(Options[0].replace(/\D/g, '')) && !_.includes(Options, 'N/A')) {
    return true;
  }
  return false;
};
export var isWeightedCategory = function isWeightedCategory(category) {
  return _.includes(['Flower', 'Pre-Rolls', 'Vaporizers', 'Concentrates', 'Concentrate'], category);
};
export var isWeightedSubcategory = function isWeightedSubcategory(subcategory) {
  return _.includes(WeightedSubcategories, subcategory);
};
export var isSubjectToExciseTax = function isSubjectToExciseTax(_ref2) {
  var type = _ref2.type;
  return !_.includes(['Accessories'], type);
};
export var getTaxInclusionNote = function getTaxInclusionNote(_ref3) {
  var _computedTaxes$salesT, _computedTaxes$cannab;
  var product = _ref3.product,
    dispensary = _ref3.dispensary,
    medical = _ref3.medical,
    _ref3$printedMenu = _ref3.printedMenu,
    printedMenu = _ref3$printedMenu === void 0 ? false : _ref3$printedMenu;
  /**
   * We use the tax calculator to get values for a single-product cart.
   * Then work backwards to determine if taxes are included or added at checkout, without having to know
   * anything about how the computation works with a dispensary's tax config.
   */
  var option = product.Options[0];
  var price = product.Prices[0];
  var computedTaxes = taxes({
    productKey: {
      quantity: 1,
      option: option,
      price: price,
      product: product
    }
  }, dispensary, medical);
  var details = _.get(computedTaxes, "details.0");
  var cannabisTaxFunc = details.cannabisTax,
    salesTaxFunc = details.salesTax,
    menuCannabisTax = details.menuCannabisTax,
    menuSalesTax = details.menuSalesTax;
  var hasCannabisCheckoutTax = cannabisTaxFunc(1) > 0;
  var hasSalesCheckoutTax = salesTaxFunc(1) > 0;
  var hasMenuCannabisTax = menuCannabisTax > 0;
  var hasMenuSalesTax = menuSalesTax > 0;
  var salesTaxExists = !_.isEmpty(computedTaxes === null || computedTaxes === void 0 || (_computedTaxes$salesT = computedTaxes.salesTaxExistence) === null || _computedTaxes$salesT === void 0 ? void 0 : _computedTaxes$salesT[medical ? "med" : "rec"]);
  var cannabisTaxExists = !_.isEmpty(computedTaxes === null || computedTaxes === void 0 || (_computedTaxes$cannab = computedTaxes.cannabisTaxExistence) === null || _computedTaxes$cannab === void 0 ? void 0 : _computedTaxes$cannab[medical ? "med" : "rec"]);
  var addedAtText = printedMenu ? "not included" : "will be added at checkout";
  var taxInclusionSentences = [];
  if (hasCannabisCheckoutTax && hasSalesCheckoutTax && !hasMenuCannabisTax && !hasMenuSalesTax) {
    taxInclusionSentences.push("Cannabis and Sales tax ".concat(addedAtText, "."));
  } else if (hasCannabisCheckoutTax && hasSalesCheckoutTax && hasMenuCannabisTax && hasMenuSalesTax) {
    taxInclusionSentences.push("All taxes included in price.");
  } else if (salesTaxExists && cannabisTaxExists && !hasCannabisCheckoutTax && !hasSalesCheckoutTax) {
    taxInclusionSentences.push("Cannabis and Sales tax not included.");
  } else {
    if (hasSalesCheckoutTax && !hasMenuSalesTax) {
      taxInclusionSentences.push("Sales tax ".concat(addedAtText, "."));
    } else if (hasSalesCheckoutTax) {
      taxInclusionSentences.push("Sales tax included.");
    } else if (salesTaxExists && !hasSalesCheckoutTax) {
      taxInclusionSentences.push("Sales tax not included.");
    }
    if (hasCannabisCheckoutTax && !hasMenuCannabisTax) {
      taxInclusionSentences.push("Cannabis tax ".concat(addedAtText, "."));
    } else if (hasCannabisCheckoutTax) {
      taxInclusionSentences.push("Cannabis tax included.");
    } else if (cannabisTaxExists && !hasCannabisCheckoutTax) {
      taxInclusionSentences.push("Cannabis tax not included.");
    }
  }
  var taxInclusionNote = taxInclusionSentences.length > 0 ? "*".concat(taxInclusionSentences.join(' ')) : '';
  return taxInclusionNote;
};
export var categoryPluralize = function categoryPluralize(category) {
  return _.includes(['Edible', 'Concentrate', 'Tincture', 'Oral'], category) ? "".concat(category, "s") : category;
};
export var categorySingularize = function categorySingularize(category) {
  return (
    // eslint-disable-next-line lodash/prefer-lodash-method
    ["Edibles", "Concentrates", "Tinctures", "Topicals", "Clones", "Seeds", "Vaporizers", "Pre-Rolls"].map(function (v) {
      return _.toLower(v);
    }).includes(_.toLower(category)) ? category.replace(/s([^s]*)$/, '') : category
  );
};
export var discountAmount = function discountAmount(price, specialPrice) {
  if (specialPrice <= 0) {
    return 0;
  }
  return (parseFloat(1 - specialPrice / price) * 100.0).toFixed(0);
};
export var availablePricingTypes = function availablePricingTypes(dispensary) {
  if (isMedOnly(dispensary)) {
    return ["med"];
  }
  if (isRecOnly(dispensary)) {
    return ["rec"];
  }
  return ["rec", "med"];
};
export var filterPricesBelowThreshold = function filterPricesBelowThreshold(product, prices) {
  var _product$Options = product.Options,
    Options = _product$Options === void 0 ? [] : _product$Options,
    _product$optionsBelow = product.optionsBelowThreshold,
    optionsBelowThreshold = _product$optionsBelow === void 0 ? [] : _product$optionsBelow;
  if (!(Options.length > 1)) {
    return prices;
  }
  if (!_.isEmpty(prices) && !_.isEmpty(optionsBelowThreshold)) {
    // find index of of each item in [options]
    // that does not match an item in [optionsBelowThreshold]
    var indices = _.map(Options, function (option, index) {
      return _.includes(optionsBelowThreshold, option) ? null : index;
    });
    var indicesToKeep = _.filter(indices, function (index) {
      return index !== null;
    });
    return _.map(indicesToKeep, function (index) {
      return prices[index];
    });
  }
  return prices;
};
export function isPotencyProduct(product) {
  return product.cbdContent || product.thcContent || !_.includes(['Accessories', 'Apparel', 'Clones'], product.type);
}
export var getKeyFromTAC = function getKeyFromTAC(cannabinoids, key, fallback) {
  return _.get(_.find(cannabinoids, function (noid) {
    var _noid$cannabinoid;
    return parseNoidAbbreviation(noid === null || noid === void 0 || (_noid$cannabinoid = noid.cannabinoid) === null || _noid$cannabinoid === void 0 ? void 0 : _noid$cannabinoid.name) === CannabinoidAbbrev.TAC;
  }), key, fallback);
};
export var getPotencyRanges = function getPotencyRanges(product) {
  var _product$THCContent, _product$CBDContent, _ref4;
  if (!product) {
    return {};
  }
  var cannabinoids = _.get(product, 'cannabinoidsV2', []);
  var tacPotencyValue = getKeyFromTAC(cannabinoids, "value", 0);
  var tacPotencyRangeV2 = [tacPotencyValue, tacPotencyValue];
  var thcPotencyRange;
  thcPotencyRange = _.isArray(product === null || product === void 0 || (_product$THCContent = product.THCContent) === null || _product$THCContent === void 0 ? void 0 : _product$THCContent.range) ? _toConsumableArray(product.THCContent.range) : [0];
  var cbdPotencyRange;
  cbdPotencyRange = _.isArray(product === null || product === void 0 || (_product$CBDContent = product.CBDContent) === null || _product$CBDContent === void 0 ? void 0 : _product$CBDContent.range) ? _toConsumableArray(product.CBDContent.range) : [0];

  // for each cannabinoid, if range does not have two values, give it two values
  if (cbdPotencyRange.length !== 2) {
    cbdPotencyRange = [0].concat(_toConsumableArray(cbdPotencyRange));
  }
  if (thcPotencyRange.length !== 2) {
    thcPotencyRange = [0].concat(_toConsumableArray(thcPotencyRange));
  }
  return _ref4 = {}, _defineProperty(_ref4, POTENCY_TYPES.CBD, cbdPotencyRange), _defineProperty(_ref4, POTENCY_TYPES.THC, thcPotencyRange), _defineProperty(_ref4, POTENCY_TYPES.TAC, tacPotencyRangeV2), _ref4;
};
export var getPotencyValues = function getPotencyValues(product) {
  var _ref5;
  if (!product) {
    return {};
  }
  var ranges = getPotencyRanges(product);
  return _ref5 = {}, _defineProperty(_ref5, POTENCY_TYPES.CBD, _.max(ranges[POTENCY_TYPES.CBD])), _defineProperty(_ref5, POTENCY_TYPES.THC, _.max(ranges[POTENCY_TYPES.THC])), _defineProperty(_ref5, POTENCY_TYPES.TAC, _.max(ranges[POTENCY_TYPES.TAC])), _ref5;
};

// should return an object with the accurate CBD and THC potency values
// if either CBD or THC is a range, the corresponding value will be an array with those potency values
// if either CBD or THC is NOT a range, the corresponding value will be an array with a single potency value
export var getAccuratePotencyValues = function getAccuratePotencyValues(product) {
  var _ref6;
  if (!product) {
    return {};
  }
  var CBDContent = product.CBDContent,
    THCContent = product.THCContent;
  var tacPotencyValue = getKeyFromTAC(product.cannabinoidsV2, 'value', 0);
  var safeTacValue = tacPotencyValue ? [tacPotencyValue] : undefined;
  return _ref6 = {}, _defineProperty(_ref6, POTENCY_TYPES.CBD, CBDContent ? getAccuratePotency(CBDContent.range) : undefined), _defineProperty(_ref6, POTENCY_TYPES.THC, THCContent ? getAccuratePotency(THCContent.range) : undefined), _defineProperty(_ref6, POTENCY_TYPES.TAC, safeTacValue), _ref6;
};
export var getAccuratePotency = function getAccuratePotency(potencyRange) {
  var isRange = isPotencyRange(potencyRange);
  if (isRange) {
    // get the lower and upper bound of the potency range
    var _potencyRange = _slicedToArray(potencyRange, 2),
      lowerBound = _potencyRange[0],
      upperBound = _potencyRange[1];

    // if the range has two indexes but the first one is 0 or null or undefined, then only return the upperBound
    // because we only want to use a range if it is between two values > 0
    if (lowerBound === 0 || _.isNil(lowerBound)) {
      return [upperBound];
    }
    // if the range has two indexes but the upperBound is null or undefined, and the lowerBound is valid, return it
    if (_.isNil(upperBound) && !_.isNil(lowerBound)) {
      return [lowerBound];
    }
    return potencyRange;
  }

  // the only case where the potency is a range and the only value is 0
  // set to null so the value can be overridden if the item is connected to a library product
  if ((potencyRange === null || potencyRange === void 0 ? void 0 : potencyRange.length) === 1 && (potencyRange[0] === null || potencyRange[0] === 0 || potencyRange[0] === undefined)) {
    return null;
  }

  // if the potency range is an empty array return null
  if ((potencyRange === null || potencyRange === void 0 ? void 0 : potencyRange.length) === 0) {
    return null;
  }

  // the only cases where potency range would be defined but isRange would be false
  // is if both values in the range are equal or the range has one value. return the first value
  if (potencyRange && !!potencyRange[0]) {
    return [potencyRange[0]];
  }
  return null;
};
export var isPotencyRange = function isPotencyRange(range) {
  if (!_.isArray(range)) {
    return false;
  }
  if (range.length !== 2) {
    return false;
  }
  if (!_.isFinite(_.toNumber(range[0])) || !_.isFinite(_.toNumber(range[1]))) {
    return false;
  }
  return range[0] !== range[1];
};
export var regulateRangeValue = function regulateRangeValue(range) {
  if (!isPotencyRange(range) && range[0] !== range[1] || !_.isArray(range)) {
    return [0, 0];
  }
  range = _.map(range, Number);
  return range[0] > range[1] ? [range[0], range[0]] : range;
};
export var getPotencyUnits = function getPotencyUnits(product) {
  var _$get, _$get2, _getKeyFromTAC, _ref7;
  if (!product) {
    return {};
  }
  var fallbackUnit = _.includes(["Edible", "Topicals", "Tincture", "CBD"], product.type) ? POTENCY_UNITS.MILLIGRAMS : POTENCY_UNITS.PERCENTAGE;
  var cbdUnit = (_$get = _.get(product, "CBDContent.unit", fallbackUnit)) !== null && _$get !== void 0 ? _$get : fallbackUnit;
  var thcUnit = (_$get2 = _.get(product, "THCContent.unit", fallbackUnit)) !== null && _$get2 !== void 0 ? _$get2 : fallbackUnit;
  var cannabinoids = _.get(product, 'cannabinoidsV2', []);
  var tacUnit = (_getKeyFromTAC = getKeyFromTAC(cannabinoids, 'unit', fallbackUnit)) !== null && _getKeyFromTAC !== void 0 ? _getKeyFromTAC : fallbackUnit;
  return _ref7 = {}, _defineProperty(_ref7, POTENCY_TYPES.CBD, cbdUnit || fallbackUnit), _defineProperty(_ref7, POTENCY_TYPES.THC, thcUnit || fallbackUnit), _defineProperty(_ref7, POTENCY_TYPES.TAC, tacUnit), _ref7;
};
function fractionToDecimal(fraction) {
  // handles non fraction inputs also like integers
  var split = _.split(fraction, '/');
  var result = split[0];
  if (split.length > 1 && parseInt(split[1], 10) !== 0) {
    result = split[0] / split[1];
  }
  return result;
}
export var getWeightAndUnits = function getWeightAndUnits(weightString) {
  if (isConcentrate(weightString)) {
    return {
      amount: parseFloat(parseGramWeight(weightString)),
      unit: 'gC'
    };
  }
  if (isGram(weightString)) {
    return {
      amount: parseFloat(parseGramWeight(weightString)),
      unit: 'g'
    };
  }
  if (isOz(weightString) || isPartialOz(weightString)) {
    var weight = parseOzWeightNoConversion(weightString);
    return {
      amount: parseFloat(fractionToDecimal(weight)),
      unit: 'oz'
    };
  }
  if (isMg(weightString)) {
    return {
      amount: parseFloat(parseMgWeightNoConversion(weightString)),
      unit: 'mg'
    };
  }
  // if our weight string is 'Any Weight'
  return null;
};
export var getPotency = function getPotency(product) {
  var _ref8;
  var _getPotencyRanges = getPotencyRanges(product),
    CBDRange = _getPotencyRanges.CBD,
    THCRange = _getPotencyRanges.THC,
    TACRange = _getPotencyRanges.TAC;
  var _getPotencyUnits = getPotencyUnits(product),
    CBDUnit = _getPotencyUnits.CBD,
    THCUnit = _getPotencyUnits.THC,
    TACUnit = _getPotencyUnits.TAC;
  var TACValue = _.max(TACRange) || ''; // TAC doesn't allow ranges

  return _ref8 = {}, _defineProperty(_ref8, POTENCY_TYPES.CBD, {
    unit: CBDUnit,
    range: CBDRange
  }), _defineProperty(_ref8, POTENCY_TYPES.THC, {
    unit: THCUnit,
    range: THCRange
  }), _defineProperty(_ref8, POTENCY_TYPES.TAC, {
    unit: TACUnit,
    value: TACValue
  }), _ref8;
};
export function getPotencyString(potency, unit) {
  var space = function space(u) {
    return u === POTENCY_UNITS.MILLIGRAMS ? ' ' : '';
  };
  return Number(potency) > 0 ? "".concat(potency).concat(space(unit)).concat(POTENCY_UNITS_DISPLAY[unit]) : '--';
}
export var getFormattedPotency = function getFormattedPotency(product) {
  var _ref9;
  if (!product) {
    return {};
  }
  var ranges = getPotencyRanges(product);
  var units = getPotencyUnits(product);
  var CBDString = getPotencyString(_.last(ranges.CBD), units.CBD);
  var THCString = getPotencyString(_.last(ranges.THC), units.THC);
  var TACString = getPotencyString(_.last(ranges[POTENCY_TYPES.TAC]), units[POTENCY_TYPES.TAC]);
  if (ranges.THC[0] > 0 && ranges.THC[0] !== ranges.THC[1]) {
    THCString = "".concat(getPotencyString(ranges.THC[0], units.THC), " - ").concat(THCString);
  }
  if (ranges.CBD[0] > 0 && ranges.CBD[0] !== ranges.CBD[1]) {
    CBDString = "".concat(getPotencyString(ranges.CBD[0], units.CBD), " - ").concat(CBDString);
  }
  return _ref9 = {}, _defineProperty(_ref9, POTENCY_TYPES.CBD, CBDString), _defineProperty(_ref9, POTENCY_TYPES.THC, THCString), _defineProperty(_ref9, POTENCY_TYPES.TAC, TACString), _ref9;
};
export var checkForPotencyValue = function checkForPotencyValue(potencyData) {
  return !isBlank(potencyData) && _.isFinite(_.toNumber(potencyData)) || isPotencyRange(potencyData);
};

// Raw availability for business-rule enforcement. Unlike getQuantityRemaining,
// this can return 0 for POS-backed products and should be used by server-side validation.
export var getRawQuantityRemaining = function getRawQuantityRemaining(product, option) {
  var _product$POSMetaData, _product$POSMetaData2;
  var _ref0 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref0$isKiosk = _ref0.isKiosk,
    isKiosk = _ref0$isKiosk === void 0 ? false : _ref0$isKiosk,
    _ref0$ignoreThreshold = _ref0.ignoreThreshold,
    ignoreThreshold = _ref0$ignoreThreshold === void 0 ? false : _ref0$ignoreThreshold,
    _ref0$defaultLimit = _ref0.defaultLimit,
    defaultLimit = _ref0$defaultLimit === void 0 ? 10 : _ref0$defaultLimit;
  if (!product || !((_product$POSMetaData = product.POSMetaData) !== null && _product$POSMetaData !== void 0 && _product$POSMetaData.children) && !product.manualInventory) {
    return defaultLimit;
  }
  var quantityRemaining = defaultLimit;
  if ((_product$POSMetaData2 = product.POSMetaData) !== null && _product$POSMetaData2 !== void 0 && _product$POSMetaData2.children && !product.manualInventory) {
    var _product$POSMetaData$ = product.POSMetaData.children,
      children = _product$POSMetaData$ === void 0 ? [] : _product$POSMetaData$;
    var POSOption = _.find(children, {
      option: option
    });
    // if none of the pos meta children match the selected option, return default limit.
    if (!POSOption) {
      return defaultLimit;
    }
    quantityRemaining = POSOption.quantity;
    var quantityAvailable = isKiosk ? POSOption.kioskQuantityAvailable : POSOption.quantityAvailable;
    if (!_.isNil(quantityAvailable) && !ignoreThreshold) {
      quantityRemaining = quantityAvailable;
    }
    quantityRemaining = parseInt(quantityRemaining, 10);
    return quantityRemaining < 0 ? 0 : quantityRemaining;
  }
  var inventoryOption = _.find(product.manualInventory, {
    option: option
  });
  if (inventoryOption) {
    quantityRemaining = inventoryOption.inventory;
  }
  return quantityRemaining < 0 ? 0 : quantityRemaining;
};

// UI-facing quantity helper. POS-backed products are floored at 1 so dropdowns
// can render cleanly; order validation should use getRawQuantityRemaining instead.
export var getQuantityRemaining = function getQuantityRemaining(product, option) {
  var _product$POSMetaData3;
  var _ref1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref1$isKiosk = _ref1.isKiosk,
    isKiosk = _ref1$isKiosk === void 0 ? false : _ref1$isKiosk,
    _ref1$ignoreThreshold = _ref1.ignoreThreshold,
    ignoreThreshold = _ref1$ignoreThreshold === void 0 ? false : _ref1$ignoreThreshold,
    _ref1$defaultLimit = _ref1.defaultLimit,
    defaultLimit = _ref1$defaultLimit === void 0 ? 10 : _ref1$defaultLimit;
  var quantityRemaining = getRawQuantityRemaining(product, option, {
    isKiosk: isKiosk,
    ignoreThreshold: ignoreThreshold,
    defaultLimit: defaultLimit
  });
  if (product !== null && product !== void 0 && (_product$POSMetaData3 = product.POSMetaData) !== null && _product$POSMetaData3 !== void 0 && _product$POSMetaData3.children && !product.manualInventory) {
    return quantityRemaining < 1 ? 1 : quantityRemaining;
  }
  return quantityRemaining;
};
export function getRangeForQuantityDropdown(_ref10) {
  var product = _ref10.product,
    option = _ref10.option,
    quantityInCart = _ref10.quantityInCart,
    isKiosk = _ref10.isKiosk,
    _ref10$defaultLimit = _ref10.defaultLimit,
    defaultLimit = _ref10$defaultLimit === void 0 ? 10 : _ref10$defaultLimit;
  var quantityRemaining = getQuantityRemaining(product, option, {
    isKiosk: isKiosk,
    defaultLimit: defaultLimit
  });
  var maxQuantityForSelection = _.clamp(quantityRemaining, 1, quantityInCart > defaultLimit ? quantityInCart : defaultLimit);
  return _.range(1, maxQuantityForSelection + 1);
}
export function getMaxQuantityForCheckout(_ref11) {
  var _dispensary$storeSett;
  var product = _ref11.product,
    option = _ref11.option,
    dispensary = _ref11.dispensary,
    isKiosk = _ref11.isKiosk,
    _ref11$defaultLimit = _ref11.defaultLimit,
    defaultLimit = _ref11$defaultLimit === void 0 ? 10 : _ref11$defaultLimit;
  var quantityRemaining = getRawQuantityRemaining(product, option, {
    isKiosk: isKiosk,
    defaultLimit: defaultLimit
  });
  if (dispensary !== null && dispensary !== void 0 && (_dispensary$storeSett = dispensary.storeSettings) !== null && _dispensary$storeSett !== void 0 && _dispensary$storeSett.quantityLimitMaxAvailable) {
    return quantityRemaining;
  }
  return _.clamp(quantityRemaining, 0, defaultLimit);
}
export var getLimitPerCustomer = function getLimitPerCustomer(product, option) {
  var defaultLimit = null;
  if (!product || !product.limitsPerCustomer) {
    return defaultLimit;
  }
  var filtered = _.filter(product.limitsPerCustomer, ["key", option]);
  if (filtered.length > 0) {
    var value = filtered[0].value;
    return value === 'Unlimited' ? defaultLimit : parseInt(value, 10);
  }
  return defaultLimit;
};
export var optionValMap = {
  '0.02g': 0.02,
  '0.05g': 0.05,
  '0.15g': 0.15,
  '.3g': 0.3,
  '0.3g': 0.3,
  '.5g': 0.5,
  '0.5g': 0.5,
  '0.7g': 0.7,
  '.7g': 0.7,
  '1g': 1.0,
  '1.0g': 1.0,
  '1.2g': 1.2,
  '1.25g': 1.25,
  '1.5g': 1.5,
  '1.75g': 1.75,
  '2g': 2.0,
  '2.5g': 2.5,
  '2.6g': 2.6,
  '2.0g': 2.0,
  '1/8oz': 3.5,
  '3g': 3.0,
  '3.0g': 3.0,
  '3.5g': 3.5,
  '3.6g': 3.6,
  '3.7g': 3.7,
  '3.75g': 3.75,
  '4.0g': 4.0,
  '4g': 4.0,
  '5g': 5.0,
  '5.0g': 5.0,
  '7g': 7.0,
  '1/4oz': 7.0,
  '14g': 14.0,
  '1/2oz': 14.0,
  '28g': 28.0,
  '1oz': 28.0,
  '57g': 57.0,
  '2oz': 57.0,
  '85g': 85.0,
  '3oz': 85.0,
  '113g': 113.0,
  '4oz': 113.0,
  '142g': 142.0,
  '5oz': 142.0,
  '170g': 170.0,
  '6oz': 170.0,
  '198g': 198.0,
  '7oz': 198.0,
  '227g': 227.0,
  '8oz': 227.0,
  'Pre-Rolls': 1.0,
  '.25gC': 0.25,
  '.3gC': 0.3,
  '.4gC': 0.4,
  '.5gC': 0.5,
  '.75gC': 0.75,
  '1gC': 1.0,
  '1.25gC': 1.25,
  '1.5gC': 1.5,
  '1.75gC': 1.75,
  '2gC': 2.0,
  '2.5gC': 2.5
};
export var isMg = function isMg(weight) {
  return weight && MG_WEIGHT_REGEX.test(weight);
};
export var isGram = function isGram(weight) {
  return weight && GRAM_WEIGHT_REGEX.test(weight);
};
export var isConcentrate = function isConcentrate(weight) {
  return weight && CONC_WEIGHT_REGEX.test(weight);
};
export var isOz = function isOz(weight) {
  return weight && OZ_WEIGHT_REGEX.test(weight);
};
export var isPartialOz = function isPartialOz(weight) {
  return weight && PARTIAL_OZ_REGEX.test(weight);
};
export var parseMgWeight = function parseMgWeight(weight) {
  var weightOnly = parseMgWeightNoConversion(weight);
  return weightOnly / MG_TO_G;
};
export var parseMgWeightNoConversion = function parseMgWeightNoConversion(weight) {
  var isMgWeight = isMg(weight);
  if (!isMgWeight) {
    return false;
  }
  return MG_WEIGHT_REGEX.exec(weight)[0].slice(0, -2);
};
export var parseGramWeight = function parseGramWeight(weight) {
  var isGramWeight = isGram(weight);
  var isConcentrateWeight = isConcentrate(weight);
  if (isGramWeight) {
    var weightOnly = GRAM_WEIGHT_REGEX.exec(weight)[0].slice(0, -1);
    return Number(weightOnly);
  }
  if (isConcentrateWeight) {
    var _weightOnly = GRAM_WEIGHT_REGEX.exec(weight)[0].slice(0, -2);
    return Number(_weightOnly);
  }
  return false;
};
export var parseOzWeightNoConversion = function parseOzWeightNoConversion(weight) {
  var isPartialOzWeight = isPartialOz(weight);
  if (isPartialOzWeight) {
    return PARTIAL_OZ_REGEX.exec(weight)[0].slice(0, -2);
  }
  var isOzWeight = isOz(weight);
  if (isOzWeight) {
    return OZ_WEIGHT_REGEX.exec(weight)[0].slice(0, -2);
  }
  return -1;
};
export var parseOzWeight = function parseOzWeight(weight, defaultWeight) {
  var partials = {
    '1/8': 3.5,
    '1/4': 7.0,
    '1/2': 14.0
  };
  var isPartialOzWeight = isPartialOz(weight);
  if (isPartialOzWeight) {
    var weightOnly = PARTIAL_OZ_REGEX.exec(weight)[0].slice(0, -2);
    return partials[weightOnly] || defaultWeight;
  }
  var isOzWeight = isOz(weight);
  if (isOzWeight) {
    var _weightOnly2 = OZ_WEIGHT_REGEX.exec(weight)[0].slice(0, -2);
    return _weightOnly2 * GRAM_TO_OZ;
  }
  if (!isOzWeight && !isPartialOzWeight) {
    return false;
  }
  return false;
};

/** @param {string | null | undefined} option */
var parseMultiplier = function parseMultiplier(option) {
  var optionParsed = option;
  var multiplier = 1;
  var match = String(optionParsed || '').match(MULTIPLIER_REGEX);
  if (match) {
    multiplier = parseInt(match[1], 10);
    if (Number.isNaN(multiplier)) {
      multiplier = 1;
    }
    // eslint-disable-next-line prefer-destructuring
    optionParsed = match[2];
  }
  return {
    multiplier: multiplier,
    optionParsed: optionParsed
  };
};

/**
 * @param {string | string[] | null | undefined} option - weight option string (e.g. "3.5g", "1/8oz") or array
 * @param {number} [defaultWeight=0.0]
 * @param {number} [quantity=1]
 * @returns {number} weight in grams
 */
export var getProductWeight = function getProductWeight() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var defaultWeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.0;
  var quantity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  if (Array.isArray(toJS(option))) {
    // eslint-disable-next-line prefer-destructuring
    option = toJS(option)[0];
  }
  if (typeof option !== 'string') {
    return parseFloat(Big(defaultWeight).times(parseFloat(quantity)).toFixed(2));
  }
  var _parseMultiplier = parseMultiplier(option),
    multiplier = _parseMultiplier.multiplier,
    optionParsed = _parseMultiplier.optionParsed;
  var NO_LETTERS_REGEX = /[a-z]/i;
  var optionValue = defaultWeight;

  // check our option hash first as an optimization then
  // revert to our parsing
  if (optionParsed === 'N/A' || _.isNil(optionParsed)) {
    optionValue = defaultWeight;
  } else if (optionValMap[optionParsed] !== undefined) {
    optionValue = optionValMap[optionParsed];
  } else if (isGram(optionParsed) || isConcentrate(optionParsed)) {
    optionValue = parseGramWeight(optionParsed);
  } else if (isOz(optionParsed) || isPartialOz(optionParsed)) {
    optionValue = parseOzWeight(optionParsed, defaultWeight);
  } else if (isMg(optionParsed)) {
    optionValue = parseMgWeight(optionParsed);
  } else if (/^(?:\d+(?:\.\d+)?|\.\d+)\s*ml$/i.test(optionParsed)) {
    // Volume in ml treated as grams for compliance (1ml ≈ 1g); supports ".5ml" and "1ml"
    optionValue = parseFloat(optionParsed.match(/^(\d+(?:\.\d+)?|\.\d+)\s*ml$/i)[1]);
  } else if (parseFloat(optionParsed) && !NO_LETTERS_REGEX.test(optionParsed)) {
    // if we didn't pass a weight unit, we can still use the weight value
    optionValue = parseFloat(optionParsed);
  } else if (!_.isFinite(optionValue)) {
    optionValue = 0;
  }
  return parseFloat(Big(optionValue).times(multiplier).times(parseFloat(quantity)).toFixed(2));
};
export var getProductNetWeightInGrams = function getProductNetWeightInGrams(product) {
  var _product$measurements, _product$measurements2;
  var value = (_product$measurements = product.measurements) === null || _product$measurements === void 0 || (_product$measurements = _product$measurements.netWeight) === null || _product$measurements === void 0 || (_product$measurements = _product$measurements.values) === null || _product$measurements === void 0 ? void 0 : _product$measurements[0];
  var unit = (_product$measurements2 = product.measurements) === null || _product$measurements2 === void 0 || (_product$measurements2 = _product$measurements2.netWeight) === null || _product$measurements2 === void 0 ? void 0 : _product$measurements2.unit;
  if (unit !== MILLIGRAMS || !value) {
    return 0;
  }
  return Number(safeToBig(value).div(MG_TO_G));
};
export var getProductVolumeInGrams = function getProductVolumeInGrams(product) {
  var _product$measurements3, _product$measurements4;
  var value = (_product$measurements3 = product.measurements) === null || _product$measurements3 === void 0 || (_product$measurements3 = _product$measurements3.volume) === null || _product$measurements3 === void 0 || (_product$measurements3 = _product$measurements3.values) === null || _product$measurements3 === void 0 ? void 0 : _product$measurements3[0];
  var unit = (_product$measurements4 = product.measurements) === null || _product$measurements4 === void 0 || (_product$measurements4 = _product$measurements4.volume) === null || _product$measurements4 === void 0 ? void 0 : _product$measurements4.unit;
  if (unit !== MILLILITERS || !value) {
    return 0;
  }
  return Number(safeToBig(value)); // 1ml === 1g
};
export var getProductVolumeInFluidOunces = function getProductVolumeInFluidOunces(product) {
  var _product$measurements5, _product$measurements6, _product$measurements7, _product$measurements8, _product$measurements9, _product$measurements0;
  var value = (_product$measurements5 = (_product$measurements6 = product.measurements) === null || _product$measurements6 === void 0 || (_product$measurements6 = _product$measurements6.volume) === null || _product$measurements6 === void 0 || (_product$measurements6 = _product$measurements6.values) === null || _product$measurements6 === void 0 ? void 0 : _product$measurements6[0]) !== null && _product$measurements5 !== void 0 ? _product$measurements5 : (_product$measurements7 = product.measurements) === null || _product$measurements7 === void 0 || (_product$measurements7 = _product$measurements7.netWeight) === null || _product$measurements7 === void 0 || (_product$measurements7 = _product$measurements7.values) === null || _product$measurements7 === void 0 ? void 0 : _product$measurements7[0];
  var unit = (_product$measurements8 = (_product$measurements9 = product.measurements) === null || _product$measurements9 === void 0 || (_product$measurements9 = _product$measurements9.volume) === null || _product$measurements9 === void 0 ? void 0 : _product$measurements9.unit) !== null && _product$measurements8 !== void 0 ? _product$measurements8 : (_product$measurements0 = product.measurements) === null || _product$measurements0 === void 0 || (_product$measurements0 = _product$measurements0.netWeight) === null || _product$measurements0 === void 0 ? void 0 : _product$measurements0.unit;
  if (!unit || !value) {
    return 0;
  }

  // if we've only been given a weight, we'll need to convert to ml
  if (unit === MILLIGRAMS || unit === GRAMS) {
    // then lets convert to ml!
    // 1ml === 1g approximately based on water density
    // so we're really just converting to grams if need be
    var gramValue = unit === MILLIGRAMS ? Number(safeToBig(value).div(1000).round(5)) : Number(safeToBig(value));
    var flOzValue = Number(safeToBig(gramValue).div(MILLILITERS_PER_OZ).round(5));
    return flOzValue;
  }
  return unit === MILLILITERS ? Number(safeToBig(value).div(MILLILITERS_PER_OZ).round(5)) : 0;
};
export var getEquivalent = function getEquivalent(product, option, quantity) {
  var _product$POSMetaData4;
  var field = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "standardEquivalent";
  var childProduct = _.find((_product$POSMetaData4 = product.POSMetaData) === null || _product$POSMetaData4 === void 0 ? void 0 : _product$POSMetaData4.children, {
    option: option
  });
  var equivalentUnit = _.get(childProduct, "".concat(field, ".unit"));
  var equivalentValue = equivalentUnit === 'g' && _.get(childProduct, "".concat(field, ".value"));
  return equivalentValue ? equivalentValue * quantity : null;
};
export function formatWeightOptions(_ref12) {
  var _ref12$options = _ref12.options,
    options = _ref12$options === void 0 ? [] : _ref12$options,
    _ref12$prices = _ref12.prices,
    prices = _ref12$prices === void 0 ? [] : _ref12$prices,
    _ref12$limitsPerCusto = _ref12.limitsPerCustomer,
    limitsPerCustomer = _ref12$limitsPerCusto === void 0 ? [] : _ref12$limitsPerCusto,
    _ref12$optionsBelowTh = _ref12.optionsBelowThreshold,
    optionsBelowThreshold = _ref12$optionsBelowTh === void 0 ? [] : _ref12$optionsBelowTh,
    _ref12$optionsBelowKi = _ref12.optionsBelowKioskThreshold,
    optionsBelowKioskThreshold = _ref12$optionsBelowKi === void 0 ? [] : _ref12$optionsBelowKi,
    _ref12$weightOnlyLabe = _ref12.weightOnlyLabel,
    weightOnlyLabel = _ref12$weightOnlyLabe === void 0 ? false : _ref12$weightOnlyLabe,
    _ref12$manualInventor = _ref12.manualInventory,
    manualInventory = _ref12$manualInventor === void 0 ? [] : _ref12$manualInventor,
    _ref12$isKiosk = _ref12.isKiosk,
    isKiosk = _ref12$isKiosk === void 0 ? false : _ref12$isKiosk,
    _ref12$showQualifying = _ref12.showQualifyingOptions,
    showQualifyingOptions = _ref12$showQualifying === void 0 ? false : _ref12$showQualifying,
    _ref12$qualifyingOpti = _ref12.qualifyingOptions,
    qualifyingOptions = _ref12$qualifyingOpti === void 0 ? [] : _ref12$qualifyingOpti;
  var chain = flow(map.convert({
    cap: false
  })(function (opt, i) {
    var price = parseFloat(prices[i]).toFixed(2);
    var label;
    if (weightOnlyLabel) {
      label = opt.weight ? opt.weight.replace("oz", " oz").replace("gC", "g") : opt.replace("oz", " oz").replace("gC", "g");
    } else {
      label = "".concat(opt.weight ? opt.weight.replace("oz", " oz").replace("gC", "g") : opt.replace("oz", " oz").replace("gC", "g"), " - $").concat(price);
    }
    return {
      value: opt,
      price: price,
      label: label
    };
  }), filter(function (_ref13) {
    var value = _ref13.value;
    var limit = getLimitPerCustomer({
      limitsPerCustomer: limitsPerCustomer
    }, value);
    if (limit === 0) {
      return false;
    }
    if (!isKiosk && optionsBelowThreshold !== null && optionsBelowThreshold !== void 0 && optionsBelowThreshold.length && _.includes(optionsBelowThreshold, value)) {
      return false;
    }
    if (isKiosk && optionsBelowKioskThreshold !== null && optionsBelowKioskThreshold !== void 0 && optionsBelowKioskThreshold.length && _.includes(optionsBelowKioskThreshold, value)) {
      return false;
    }
    if (manualInventory !== null && manualInventory !== void 0 && manualInventory.length) {
      var inventoryOption = _.find(manualInventory, ["option", value]);
      if (inventoryOption) {
        return inventoryOption.inventory > 0;
      }
      return true;
    }
    if (showQualifyingOptions && !_.includes(qualifyingOptions, value)) {
      return false;
    }
    return true;
  }), uniqBy(function (_ref14) {
    var value = _ref14.value;
    return _.replace(value, 'C', '');
  }));
  return chain(options);
}
export var getThreshold = function getThreshold(product, integration) {
  return ((integration === null || integration === void 0 ? void 0 : integration.thresholds) || {})[product.type] || 5;
};
export var imgixProductImageURL = function imgixProductImageURL(imagePath) {
  return replaceAWSSourceWithImgix(imagePath);
};
export var imageToUse = function imageToUse() {
  var _product$images, _$head, _$head2, _product$brand, _product$brand2, _ref15, _ref16, _ref17, _ref18;
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var activeImages = _.filter((_product$images = product.images) !== null && _product$images !== void 0 ? _product$images : [], ["active", true]);
  var productImage = _.isEmpty((_$head = _.head(activeImages)) === null || _$head === void 0 ? void 0 : _$head.url) ? null : (_$head2 = _.head(activeImages)) === null || _$head2 === void 0 ? void 0 : _$head2.url;
  var brandImage = _.isEmpty((_product$brand = product.brand) === null || _product$brand === void 0 ? void 0 : _product$brand.imageUrl) ? null : (_product$brand2 = product.brand) === null || _product$brand2 === void 0 ? void 0 : _product$brand2.imageUrl;
  var productStockImage = _.isEmpty(product.stockImage) ? null : product.stockImage;
  var legacyBrandImage = _.isEmpty(product.brandLogo) ? null : product.brandLogo;
  var legacyProductImage = _.isEmpty(product.Image) ? null : product.Image;
  var legacyDefaultImageLookupType = product.type === 'Flower' && product.strainType ? product.strainType : product.type;
  var legacyDefaultImage = legacyDefaultImageLookupType ? DefaultImages[legacyDefaultImageLookupType] : DefaultImages.Flower;
  return (_ref15 = (_ref16 = (_ref17 = (_ref18 = productImage !== null && productImage !== void 0 ? productImage : brandImage) !== null && _ref18 !== void 0 ? _ref18 : legacyBrandImage) !== null && _ref17 !== void 0 ? _ref17 : productStockImage) !== null && _ref16 !== void 0 ? _ref16 : legacyProductImage) !== null && _ref15 !== void 0 ? _ref15 : legacyDefaultImage;
};
export var getCanonicalIDForOption = function getCanonicalIDForOption(product, option) {
  if (product.POSMetaData.children.length) {
    var _$find;
    return (_$find = _.find(product.POSMetaData.children, {
      option: option
    })) === null || _$find === void 0 ? void 0 : _$find.canonicalID;
  }
  return product.POSMetaData.canonicalID;
};
export var formatWeight = function formatWeight(valProp) {
  /*
   * format a weight for comparison
   * acceptable units of mass from js-quantities
   * ["AMU", "carat", "dalton", "dram", "grain", "gram", "kilogram",
   * "metric-ton", "ounce", "pound", "short-ton", "slug", "stone"]
   */
  var possibleWeights = [{
    str: " oz",
    repl: " ounce"
  }, {
    str: "oz",
    repl: " ounce"
  }, {
    str: " g",
    repl: " gram"
  }, {
    str: "g",
    repl: " gram"
  }, {
    str: " gC",
    repl: " gram"
  }, {
    str: "gC",
    repl: " gram"
  }];
  var val = valProp.replace("[dot]", ".");
  var matchedStringIndex = "";
  _.forEach(possibleWeights, function (w, i) {
    return _.includes(val, w.str) ? matchedStringIndex = i : null;
  });
  if (_.isString(matchedStringIndex)) {
    console.error("Unable to parse ", val);
    return new Error();
  }
  var unitTypedVal = val.replace(possibleWeights[matchedStringIndex].str, possibleWeights[matchedStringIndex].repl).replace('  ', ' ');
  // convert to decimal if needed
  var decimalVal = unitTypedVal;
  if (_.includes(unitTypedVal, '/')) {
    var valUnitSplit = _.split(unitTypedVal, ' ');
    var fractionSplit = _.split(valUnitSplit[0], '/');
    var decimal = parseInt(fractionSplit[0], 10) / parseInt(fractionSplit[1], 10);
    decimalVal = "".concat(decimal, " ").concat(valUnitSplit[1]);
  }
  return decimalVal;
};

// Temporarily check the Title Cased effects and camelCased effects
export var filterLegacyEffects = function filterLegacyEffects(effects) {
  return _.filter(effects, function (effect) {
    return _.includes(productEffects, effect) || _.includes(normalizeProductEffects(productEffects), effect);
  });
};
export var normalizeProductEffects = function normalizeProductEffects(effects) {
  return _.map(effects, function (effect) {
    return _.camelCase(effect);
  });
};

// Returns normalized (camel case) effect keys where the effect value is greater than 0
export var parseEffects = function parseEffects(effects) {
  var appliedEffectKeys = _.keys(_.pickBy(effects, function (value, _key) {
    return _.toNumber(value) > 0;
  }));
  var normalizedEffectKeys = normalizeProductEffects(appliedEffectKeys);
  return filterLegacyEffects(normalizedEffectKeys);
};
export var applicableEffectsList = function applicableEffectsList(_ref19) {
  var state = _ref19.state;
  var effectList = productEffects;
  if (state && state.length) {
    var restrictedEffects = getComplianceConfig(state, "restrictions.effects");
    if (restrictedEffects !== null && restrictedEffects !== void 0 && restrictedEffects.length) {
      effectList = _.without.apply(_, [effectList].concat(_toConsumableArray(restrictedEffects)));
    }
  }
  return effectList;
};
export var applicableEffects = function applicableEffects(_ref20) {
  var effects = _ref20.effects,
    state = _ref20.state;
  var effectList = applicableEffectsList({
    state: state
  });
  return _.pickBy(effects, function (value, key) {
    return _.isFinite(parseInt(value, 10)) && parseInt(value, 10) > 0 && _.includes(effectList, key);
  });
};
export function highestMatchingPrices(menuType, p1, p2) {
  var p1Price = p1["".concat(menuType, "Prices")];
  var p2Price = p2["".concat(menuType, "Prices")];
  if (p1Price.length === 1 && p2Price.length === 1) {
    return [p1Price[0], p2Price[0]];
  }
  for (var p1Index = p1Price.length - 1; p1Index >= 0; --p1Index) {
    for (var p2Index = p2Price.length - 1; p2Index >= 0; --p2Index) {
      if (p1.Options[p1Index] === p2.Options[p2Index]) {
        return [p1Price[p1Index], p2Price[p2Index]];
      }
    }
  }

  // worst comes to worst just return the cheapest prices...
  // (previous behavior)
  return [p1Price[0], p2Price[0]];
}
export function getSortingFunctions(menuType) {
  return {
    custom: function custom(p1, p2) {
      return p1.weight - p2.weight;
    },
    brand: function brand(p1, p2) {
      if (p1.brandName === null) {
        return 1;
      }
      if (p2.brandName === null) {
        return -1;
      }
      if (p1.brandName > p2.brandName) {
        return 1;
      }
      if (p1.brandName < p2.brandName) {
        return -1;
      }
      if (p1.Name > p2.Name) {
        return 1;
      }
      if (p1.Name < p2.Name) {
        return -1;
      }
      return 0;
    },
    alpha: function alpha(p1, p2) {
      if (p1.Name > p2.Name) {
        return 1;
      }
      if (p1.Name < p2.Name) {
        return -1;
      }
      return 0;
    },
    priceLowToHigh: function priceLowToHigh(p1, p2) {
      var _highestMatchingPrice = highestMatchingPrices(menuType, p1, p2),
        _highestMatchingPrice2 = _slicedToArray(_highestMatchingPrice, 2),
        p1Price = _highestMatchingPrice2[0],
        p2Price = _highestMatchingPrice2[1];
      return p1Price - p2Price;
    },
    priceHighToLow: function priceHighToLow(p1, p2) {
      var _highestMatchingPrice3 = highestMatchingPrices(menuType, p1, p2),
        _highestMatchingPrice4 = _slicedToArray(_highestMatchingPrice3, 2),
        p1Price = _highestMatchingPrice4[0],
        p2Price = _highestMatchingPrice4[1];
      return p2Price - p1Price;
    },
    potency: function potency(p1, p2) {
      var p1Potency = getPotencyValues(p1);
      var p2Potency = getPotencyValues(p2);
      if (!p2Potency.THC && !p1Potency.THC) {
        return Number(p2Potency.CBD || 0) - Number(p1Potency.CBD || 0);
      }
      return Number(p2Potency.THC || 0) - Number(p1Potency.THC || 0);
    },
    strain: function strain(p1, p2) {
      return StrainTypeOrder[p1.strainType] - StrainTypeOrder[p2.strainType];
    }
  };
}
export var getProductBasePrice = function getProductBasePrice(medicalOrder, item) {
  var _item$product$preTaxR;
  var priceIndex = _.indexOf(item.product.Options, item.option);
  if (medicalOrder) {
    var _item$product$preTaxM;
    return ((_item$product$preTaxM = item.product.preTaxMedPrices) === null || _item$product$preTaxM === void 0 ? void 0 : _item$product$preTaxM[priceIndex]) || item.price;
  }
  return ((_item$product$preTaxR = item.product.preTaxRecPrices) === null || _item$product$preTaxR === void 0 ? void 0 : _item$product$preTaxR[priceIndex]) || item.price;
};
export var validateNumber = function validateNumber(value) {
  if (value === '' || _.isFinite(value)) {
    return value;
  }
  return null;
};

// TODO should we also be considering units here?
export var saleSatisfiesWeightCondition = function saleSatisfiesWeightCondition(inputWeight, operator, operatorWeights) {
  var appliesToAnyWeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (appliesToAnyWeight) {
    return true;
  }
  if (!operatorWeights || operatorWeights.length < 1) {
    return false;
  }

  /*
     here if operator weights exists we know there is some restriction
     and if that restriction doesn't include n/a we can return false
     this will prevent n/a from getting accepted as part of a weighted sale
     and will also allow us in the future to potentially include n/a as an option
     for a weighted sale (not that we would?)
  */
  if (_.toLower(inputWeight) === 'n/a') {
    return _.some(operatorWeights, function (opWeight) {
      return _.toLower(opWeight) === _.toLower(inputWeight);
    });
  }

  // If equalTo or an array of weights (v1 discount sync only)
  if (operator === 'equalTo' || operatorWeights.length > 1) {
    return _.some(operatorWeights, function (opWeight) {
      return parseFloat(inputWeight) === parseFloat(opWeight.toString());
    });
  }
  if (operator === 'greaterThan') {
    return parseFloat(inputWeight) > parseFloat(operatorWeights === null || operatorWeights === void 0 ? void 0 : operatorWeights[0]);
  }
  if (operator === 'greaterThanEqualTo') {
    return parseFloat(inputWeight) >= parseFloat(operatorWeights === null || operatorWeights === void 0 ? void 0 : operatorWeights[0]);
  }
  return true;
};

/** @return {CategoriesForMenu} */
export var getCategoriesForMenuForState = function getCategoriesForMenuForState(state) {
  var categories = _.map(CategoriesForMenu, function (category) {
    if (category.key === 'edibles' && state === 'PA') {
      return {
        key: 'ingestibles',
        label: 'Ingestibles',
        value: 'Edible'
      };
    }
    return category;
  });
  return categories;
};
export var getSubcategoryOptionsForState = function getSubcategoryOptionsForState(state) {
  var options = _.clone(SubcategoryOptions);
  if (state === 'FL') {
    _.set(options, 'Edible', _.filter(options.Edible, function (_ref21) {
      var key = _ref21.key;
      return key !== 'drinks';
    }));
  }
  return options;
};

// eslint-disable-next-line lodash/prefer-lodash-method
export var getCategoryForProduct = function getCategoryForProduct(product) {
  return CategoryOptions.find(function (_ref22) {
    var value = _ref22.value;
    return value === (product === null || product === void 0 ? void 0 : product.type);
  });
};
export var getCategoryOptionsForRetailer = function getCategoryOptionsForRetailer(dispensary) {
  var _dispensary$location;
  var _ref23 = (_dispensary$location = dispensary === null || dispensary === void 0 ? void 0 : dispensary.location) !== null && _dispensary$location !== void 0 ? _dispensary$location : {},
    state = _ref23.state;
  var options = _.map(CategoryOptions, function (category) {
    if (category.key === 'edibles') {
      if (state === 'FL') {
        return {
          key: 'edibles',
          label: 'Edibles',
          value: 'Edible',
          subcategories: _.filter(SubcategoryOptions.Edible, function (_ref24) {
            var key = _ref24.key;
            return key !== 'drinks';
          })
        };
      }
      if (state === 'PA') {
        return {
          key: 'ingestibles',
          label: 'Ingestibles',
          value: 'Edible',
          subcategories: SubcategoryOptions.Edible
        };
      }
    }
    return category;
  });
  return options;
};
export var getSubcategoryOptionsForRetailer = function getSubcategoryOptionsForRetailer(dispensary) {
  var _dispensary$location2;
  var _ref25 = (_dispensary$location2 = dispensary === null || dispensary === void 0 ? void 0 : dispensary.location) !== null && _dispensary$location2 !== void 0 ? _dispensary$location2 : {},
    state = _ref25.state;
  var options = _.clone(SubcategoryOptions);
  if (state === 'FL') {
    _.set(options, 'Edible', _.filter(options.Edible, function (_ref26) {
      var key = _ref26.key;
      return key !== 'drinks';
    }));
  }
  return options;
};
export var getProductImage = function getProductImage() {
  var _product$active, _product$origin;
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var productImage = {
    _id: product._id,
    url: product.url,
    userId: product.userId,
    active: (_product$active = product.active) !== null && _product$active !== void 0 ? _product$active : true,
    origin: (_product$origin = product.origin) !== null && _product$origin !== void 0 ? _product$origin : 'admin',
    description: '',
    label: ''
  };
  return productImage;
};
export var getFirstActiveImage = function getFirstActiveImage(images) {
  // eslint-disable-next-line lodash/prefer-lodash-method
  var firstActiveImage = images.find(function (img) {
    return img.active === true;
  });
  return firstActiveImage;
};
export var strainEffects = {
  Indica: {
    Relaxed: 9,
    Sleepy: 8,
    Happy: 8
  },
  Sativa: {
    Energetic: 9,
    Happy: 9,
    Creative: 8,
    Focused: 8,
    Inspired: 8
  },
  Hybrid: {
    Calm: 9,
    Happy: 8,
    Relaxed: 6,
    Energetic: 5
  },
  'High CBD': {
    'Clear Mind': 9,
    Calm: 8,
    Relaxed: 5,
    Happy: 5
  }
};
export var getFilteredProduct = /*#__PURE__*/function () {
  var _ref27 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(productId, apolloClient) {
    var variables, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          variables = {
            perPage: 1,
            productsFilter: {
              productId: productId,
              limit: 1
            }
          };
          _context.next = 3;
          return apolloClient.query({
            fetchPolicy: 'network-only',
            query: adminFilteredProducts,
            variables: variables
          });
        case 3:
          response = _context.sent;
          return _context.abrupt("return", _.get(response, 'data.filteredProducts.products[0]', null));
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getFilteredProduct(_x, _x2) {
    return _ref27.apply(this, arguments);
  };
}();

/**
 * @param {Object} product
 * @param {Object[]} parsedOptions
 * @returns {boolean}
 */
export function isOutOfStock(product, parsedOptions) {
  var _product$POSMetaData5;
  return ((_product$POSMetaData5 = product.POSMetaData) === null || _product$POSMetaData5 === void 0 || (_product$POSMetaData5 = _product$POSMetaData5.children) === null || _product$POSMetaData5 === void 0 || (_product$POSMetaData5 = _product$POSMetaData5[0]) === null || _product$POSMetaData5 === void 0 ? void 0 : _product$POSMetaData5.quantity) === 0 || (parsedOptions === null || parsedOptions === void 0 ? void 0 : parsedOptions.length) === 0;
}
export var getSpecialsPerQualifyingWeight = function getSpecialsPerQualifyingWeight(_ref28) {
  var option = _ref28.option,
    _ref28$bogoSpecials = _ref28.bogoSpecials,
    bogoSpecials = _ref28$bogoSpecials === void 0 ? [] : _ref28$bogoSpecials;
  var conditionIds = [];
  var rewardIds = [];
  _.forEach(bogoSpecials, function (special) {
    if (_.includes(special === null || special === void 0 ? void 0 : special.qualifyingConditionOptions, option)) {
      conditionIds.push(special.specialId);
    }
    if (_.includes(special === null || special === void 0 ? void 0 : special.qualifyingRewardOptions, option)) {
      rewardIds.push(special.specialId);
    }
  });
  return {
    conditionIds: conditionIds,
    rewardIds: rewardIds
  };
};